import { getMap } from '../../atoms/map/utils/getMap'
import { findLayer } from '../utils/findLayer'

/**
 * Remove all RoutePolylines Features from the Map
 */
export function clearRoutePolylineFeatures() {
  const map = getMap()
  const layer = findLayer(map, 'routePolyline')

  layer.getSource()?.clear()
}
